import { useGetReservation } from '#/hooks/useGetReservation';
import RentalsReservation from '@jucy-nakuru/common/services/JucyRentalsApi/RentalsReservation';
import { Booking } from '@jucy-ui/common';

export const useRefToBookingNumber = (reservationReference: string): string => {
    const reservation = useGetReservation(reservationReference).data;

    if (!reservation) {
        return '';
    }
    return formatBookingNumber(reservation);
};

export const formatBookingNumber = (reservation?: RentalsReservation | Booking): string => {
    if (!reservation) {
        return '';
    }

    if ('pickUpBranch' in reservation) {
        return `#${reservation.pickUpBranch}-${reservation.reservationId};`;
    }

    if ('pickUpLocation' in reservation) {
        return `#${reservation.pickUpLocation}-${reservation.reservationId};`;
    }

    return 'pickUpLocationCode' in reservation ? `#${reservation.pickUpLocationCode}-${reservation.reservationId}` : ';';
};
